import { schema } from 'normalizr';

export const feeSchema = new schema.Entity('formFee');
